<script>

    import app from '../data/app.svelte.js';

    import Icon from './Icon.svelte';
    import salonIcon from '../assets/icons/salon.svg?raw';

</script>

<style>

    
    div {
        display: flex;
        align-items: center;
        gap: 0.8em;
    }

    .placeholder {
        background-color: #88888888;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .placeholder :global(svg) {
        opacity: 0.3;
    }

    img, .placeholder {
        border: 1px solid rgba(0, 0, 0, 0.3);
        border-radius: 50%;
        width: 2.6em;
        height: 2.6em;
    }

    strong {
        opacity: 0.7;
    }

    span {
        font-size: 0.8em;
        opacity: 0.7;
    }

</style>

<div>
    {#if app.salon.name}
        {#if app.salon.photos?.length}
            <img src={app.salon.photos[0] + '?w=96&h=96&fit=crop'} alt={app.salon.name} />
        {:else}
            <div class='placeholder'>
                <Icon data={salonIcon} />
            </div>
        {/if}

        <strong>{app.salon.name}</strong>
        <span>{app.salon.address}, {app.salon.city}, Tel. {app.salon.telephone}</span>
    {/if}
</div>